const STATUSES = {
  active: 'active',
  demo: 'demo',
  churned: 'churned',
};

// eslint-disable-next-line import/prefer-default-export
export { STATUSES };
